
























































import {
  computed,
  defineComponent,
  onMounted,
  ref,
} from "@nuxtjs/composition-api";
import { storeToRefs } from "pinia";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import {
  AvailablePaymentMethod,
  usePaymentCard,
  usePaymentProvider,
  useUser,
} from "~/composables";
import { useCheckoutStore } from "~/stores/checkout";
import JetRadio from "../../molecules/JetRadio/JetRadio.vue";
import PaymentCardContent from "../PaymentCard/PaymentCardContent.vue";
import PaymentCardSummary from "../PaymentCard/PaymentCardSummary.vue";

export default defineComponent({
  name: "PaymentMethods",
  components: {
    JetRadio,
    PaymentCardContent,
    PaymentCardSummary,
    SkeletonLoader,
  },
  setup() {
    const { getPaymentMethods, setPaymentMethod } = usePaymentProvider();
    const paymentMethods = ref<AvailablePaymentMethod[]>([]);
    const selectedPaymentMethodCode = ref<string | null>(null);
    const checkoutStore = useCheckoutStore();
    const { selectedPaymentMethod } = storeToRefs(checkoutStore);
    const { isAuthenticated } = useUser();
    const {
      decrypt,
      selectedPaymentCard,
      selectedInstallment,
      resetPaymentCardData,
    } = usePaymentCard();
    const loadingPaymentMethods = ref(true);

    const isUserAuthenticated = computed(() => isAuthenticated.value);

    onMounted(async () => {
      try {
        paymentMethods.value = await getPaymentMethods();
      } finally {
        loadingPaymentMethods.value = false;
      }
      if (paymentMethods.value.length === 0) {
        paymentMethods.value = await getPaymentMethods();
      }
    });

    const definePaymentMethods = async (paymentMethodCode: string) => {
      setPaymentMethod(paymentMethodCode);
      selectedPaymentMethodCode.value = paymentMethodCode;

      if (paymentMethodCode !== "jetcred") {
        resetPaymentCardData();
      }
    };

    const isJetCredSelected = computed(
      () => selectedPaymentMethod.value === "jetcred"
    );

    const showPaymentList = computed(
      () =>
        !isJetCredSelected.value ||
        (selectedPaymentCard.value && selectedInstallment.value)
    );

    return {
      paymentMethods,
      definePaymentMethods,
      isJetCredSelected,
      selectedPaymentMethod,
      selectedPaymentCard,
      selectedInstallment,
      showPaymentList,
      decrypt,
      loadingPaymentMethods,
      isUserAuthenticated,
    };
  },
});
